/*
 * Copyright © 2026 Bruce Matin,  ALL RIGHTS RESERVED!
 */

import React, { useEffect, useState } from 'react';
import { ItemCard } from './ItemCard';
import { useTheme } from '../theme';
import { useLocation } from '../App';
import { itemService } from '../services/itemService';

const RecentlyListed: React.FC = () => {
  const theme = useTheme();
  const location = useLocation();
  const [items, setItems] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    itemService.listItems({ 
      sort: 'recent', 
      limit: 8,
      lat: location.latitude,
      lng: location.longitude,
      radius: location.radius
    })
      .then(res => {
        if (res.data.data) {
          setItems(res.data.data.map((item: any) => ({
            ...item,
            image: item.imageUrl,
            storeId: item.storeId
          })));
        }
        setLoading(false);
      })
      .catch(err => {
        console.error('Error fetching recent items:', err);
        setLoading(false);
      });
  }, [location.latitude, location.longitude, location.radius]);

  if (loading) {
    return <div className="py-12 text-center">Loading recent items...</div>;
  }

  if (items.length === 0) {
    return null;
  }

  return (
    <section className="py-12 border-t" style={{ borderColor: theme.colors.border }}>
      <h2 className="text-3xl font-bold mb-8" style={{ color: theme.colors.text }}>
        Recently Listed
      </h2>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {items.map((item) => (
          <div key={item.id} className="relative group overflow-hidden" style={{ borderRadius: `${theme.radius.lg}px` }}>
            <div className="absolute top-3 left-3 z-10 px-2 py-1 rounded bg-blue-600 text-white text-xs font-bold shadow-md">
              NEW
            </div>
            <ItemCard item={item} />
          </div>
        ))}
      </div>
      
      <div className="mt-12 text-center">
        <button 
          className="px-8 py-3 rounded-full font-bold transition-all hover:shadow-md"
          style={{ 
            backgroundColor: theme.colors.surface, 
            borderColor: theme.colors.border,
            border: '1px solid',
            color: theme.colors.text
          }}
        >
          Load More
        </button>
      </div>
    </section>
  );
};

export default RecentlyListed;
